import React from 'react';
import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Settings from './pages/Settings';
import StaticPathDemo from './pages/StaticPathDemo';
import OPMEditorPage from './pages/OPMEditorPage';
import OPMEditorCVPage from './pages/OPMEditorCVPage';
import Login from './pages/Login';
import KnowledgeGraphPage from './pages/KnowledgeGraphPage';
import NotFound from './pages/NotFound';
import DataMapEditorPage from './pages/DataMapEditorPage';
import OPMX6DemoPage from './pages/OPMX6DemoPage';

const OPMEditorCVRedirect: React.FC = () => {
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: '/opm-editor', search: location.search }}
      replace
    />
  );
};

// 获取基础路径，移除末尾的斜杠（如果有的话）
const getBasename = () => {
  const basePath = import.meta.env.VITE_BASE_PATH || '/';
  return basePath === '/' ? '' : basePath.replace(/\/$/, '');
};

export const router = createBrowserRouter(
  [
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: 'about',
          element: <About />,
        },
        {
          path: 'settings',
          element: <Settings />,
        },
        {
          path: 'static-path-demo',
          element: <StaticPathDemo />,
        },
        {
          path: 'opm-editor',
          // 正式启用 OPMCV 版本（新路由）
          element: <OPMEditorCVPage />,
        },
        {
          path: 'opm-editor-legacy',
          // 旧版 OPM 编辑器：用于备份与对比
          element: <OPMEditorPage />,
        },
        {
          path: 'opm-editor-cv',
          element: <OPMEditorCVRedirect />,
        },
        {
          path: 'knowledge-graph',
          element: <KnowledgeGraphPage />,
        },
        {
          path: 'data-map-editor',
          element: <DataMapEditorPage />,
        },
        {
          path: 'opm-x6-demo',
          element: <OPMX6DemoPage />,
        },
      ],
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ],
  {
    basename: getBasename(),
  }
);
